import { render, staticRenderFns } from "./set-props.vue?vue&type=template&id=b870cdb4&scoped=true&"
import script from "./set-props.vue?vue&type=script&lang=js&"
export * from "./set-props.vue?vue&type=script&lang=js&"
import style0 from "./set-props.vue?vue&type=style&index=0&id=b870cdb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b870cdb4",
  null
  
)

export default component.exports